module.exports = __webpack_public_path__ + "img/youtube-video.194f6450.svg";